import Vue from "vue";

export default {
    namespaced: true,
    state: {
        user: '',
        groupName: '',
        groupId: '',
        groups: [],
        roles: [],
        groupRoles: [],
        entityType: '',
        multiGroupUser: false,
        adminImpersonationEntityType: '',
        adminImpersonationGroupId: '',
        currentAdminGroupId: '',
        currentAdminGroupName: '',
        currentCounty: 28,
        surveyResponseId: null,
        surveyKey: null,
        tokenExpiration: null
    },
    getters: {
        groupName(state) {
            console.log("User Store")
            return state.user.groupName;
        },
        groupId(state) {
            return state.user.groupId;
        },
        currentCounty(state) {
            return state.currentCounty
        },
        isNapaProperty(state) {
            console.log("Vuex Check County Type! Value: " + state.currentCounty);
            return state.currentCounty === 28 || state.currentCounty === "28";
        }
    },
    actions: {
        getGroup(context) {
            return context.state.groupId;
        },
        getGroupInfo: function (context) {
            Vue.prototype.$http.get("/groups/name/" + context.state.currentAdminGroupId, {
                headers: {
                    'content-type': 'application/json'
                }
            }).then(response => {
                context.state.currentAdminGroupName = response.data.name;
                context.state.currentCounty = response.data.county;
            }).catch(error => {
                console.log("Error getting Data: " + error);
            });
        },
        updateGroupInfo: function (context, commit) {
            Vue.prototype.$http.get(`/groups/${commit}`, {
                headers: {
                    'content-type': 'application/json'
                }
            }).then(response => {
                context.state.currentAdminGroupName = response.data.name;
                context.state.currentCounty = response.data.county;
                localStorage.setItem("county", response.data.county);
            }).catch(error => {
                console.log("Error getting Data: " + error);
            });
        }
    },

    mutations: {
        adminImpersonationGroupId(state, commit) {
            state["adminImpersonationGroupId"] = commit;
        },
        adminImpersonationEntityType(state, commit) {
            state["adminImpersonationEntityType"] = commit;
        },
        currentCounty(state, commit) {
            state["currentCounty"] = commit;
        },
        entityType(state, commit) {
            state["entityType"] = commit;
        },
        groups(state, commit) {
            state["groups"] = commit;
        },
        groupId(state, commit) {
            state["groupId"] = commit;
        },
        groupName(state, commit) {
            state["groupName"] = commit;
        },
        groupRoles(state, commit) {
            state["groupRoles"] = commit;
        },
        multiGroupUser(state, commit) {
            state["multiGroupUser"] = commit;
        },
        roles(state, commit) {
            state["roles"] = commit;
        },
        surveyResponseId(state, commit) {
            state["surveyResponseId"] = commit;
        },
        surveyKey(state, commit) {
            state["surveyKey"] = commit;
        },
        tokenExpiration(state, commit) {
            state["tokenExpiration"] = commit;
        },
        user(state, commit) {
            state["user"] = commit;
        },
    }
}
